import { render, staticRenderFns } from "./tableBox.vue?vue&type=template&id=65b0f8ab&scoped=true"
import script from "./tableBox.vue?vue&type=script&lang=js"
export * from "./tableBox.vue?vue&type=script&lang=js"
import style0 from "./tableBox.vue?vue&type=style&index=0&id=65b0f8ab&prod&lang=stylus&scoped=true"
import style1 from "./tableBox.vue?vue&type=style&index=1&id=65b0f8ab&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b0f8ab",
  null
  
)

export default component.exports